import { DecimalPipe, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DropdownModule, InputTextModule, SelectItem } from 'primeng';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Please note that the below const is also used by the B2C booking tool for manual kerb weight entry - please consider this when making changes to the below values :)
export const vehicleKerbWeight = {
  minimum: 800,
  maximum: 44000,
};

@Component({
  selector: 'app-vehicle-kerb-weight-input',
  templateUrl: 'vehicle-kerb-weight-input.component.html',
  styleUrls: ['vehicle-kerb-weight-input.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    DropdownModule,
    FormsModule,
    DecimalPipe,
    InputTextModule,
    ReactiveFormsModule,
    NgClass,
  ],
})
export class VehicleKerbWeightInputComponent {
  options: SelectItem[] = [
    { value: 3499, label: 'Less than 3.5t' },
    { value: 7499, label: '3.5t - 7.5t' },
    { value: 17999, label: '7.5t - 18t' },
    { value: 43999, label: '18t - 44t' },
  ];

  minKerbWeight = vehicleKerbWeight.minimum;
  maxKerbWeight = vehicleKerbWeight.maximum;

  selectedWeight: any;

  kerbWeight: number;
  private oldKerbWeightEntry: number;

  limitKerbWeight(element) {
    let max_chars = 6;

    if (
      !/^\d$/.test(element.key) &&
      !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(element.key)
    ) {
      element.preventDefault();
      return;
    }

    if (
      element.target.value.length >= max_chars &&
      !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(element.key)
    ) {
      element.preventDefault();
      return;
    }

    this.oldKerbWeightEntry = this.kerbWeight;
    this.kerbWeight = element.target.value;
  }

  @Input() isTransported: boolean = false;

  // number is the upper weight of the range selected
  @Output() onWeightChanged = new EventEmitter<number>();

  onSelectedWeightChanged() {
    this.onWeightChanged.emit(this.selectedWeight);
  }

  onInputWeightChanged() {
    this.onWeightChanged.emit(this.kerbWeight);
  }
}
